import angular from 'angular';
import '../../common/localizationMapService';

const groupsServices = angular.module('applicationModule.groupsServices', []);

groupsServices.factory('Group', ['GroupAPI', function (GroupAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return GroupAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (groupId, appId) {
            return GroupAPI.getGroup(groupId, appId);
        },
        save: function (group, editMode) {
            if (editMode) {
                return GroupAPI.editGroup(group);
            } else {
                return GroupAPI.createGroup(group);
            }
        },
        remove: function (groupId, appId) {
            return GroupAPI.removeGroup(groupId, appId);
        },
        usersList: function (appId, groupId, params) {
            return GroupAPI.usersList(appId, groupId, params)
                .then(function (response) {
                    return response.data;
                });
        }
    };
}]);

groupsServices.service('GroupAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/group/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.createGroup = function (group) {
        return $http.post(API_URL + 'create', group);
    };
    this.getGroup = function (groupId, appId) {
        return $http.get(API_URL + groupId + '/' + appId);
    };

    this.editGroup = function (group) {
        return $http.put(API_URL + 'update/' + group.id, group);
    };

    this.removeGroup = function (groupId, appId) {
        return $http.delete(API_URL + 'delete/' + groupId + '/' + appId);
    };

    this.usersList = function (appId, groupId, params) {
        return $http.get(API_URL + groupId + '/users/list', {
            params: angular.extend(AppsoupAPI.getTableParams(params), {
                application_id: appId,
                group_id: groupId
            })
        });
    };
}]);

export default groupsServices;
